/**
 * Excel Orchestrator — System Prompt Builder
 *
 * Assembles the 5-section system prompt following the same pattern as
 * editChart/prompt/index.ts (buildEditChartSystemPrompt).
 */
import { getIntroSection, EXCEL_ORCHESTRATOR_INTRO } from "./intro";
import { buildToolsSection } from "./tools";
import { getSuggestionsSection, EXCEL_ORCHESTRATOR_SUGGESTIONS } from "./suggestions";
import { getContextNoteSection, EXCEL_ORCHESTRATOR_CONTEXT_NOTE } from "./contextNote";
import { getEvaluationSection, EXCEL_ORCHESTRATOR_EVALUATION } from "./evaluation";
import { SystemPromptBuilder } from "../../../agents/base/systemPrompt";
export function buildExcelOrchestratorSystemPrompt(tools = []) {
    return SystemPromptBuilder.build({
        sections: {
            intro: getIntroSection(),
            tools: () => buildToolsSection(tools),
            suggestions: getSuggestionsSection(),
            contextNote: getContextNoteSection(),
            evaluation: getEvaluationSection(),
        },
        separator: "\n\n",
    });
}
export { getIntroSection, buildToolsSection, getSuggestionsSection, getContextNoteSection, getEvaluationSection, EXCEL_ORCHESTRATOR_INTRO, EXCEL_ORCHESTRATOR_SUGGESTIONS, EXCEL_ORCHESTRATOR_CONTEXT_NOTE, EXCEL_ORCHESTRATOR_EVALUATION, };
